import { UserViewModel } from "../../interfaces/viewmodels/userviewmodel"

export namespace AccountActions {
   export class GetUserByEmail {
      static readonly type = '[Account] Get User Details ByEmail'
      constructor(public payload: { email: string }) {}
    }

    export class GetUserDetails {
      static readonly type = '[Account] Get User Details'
      constructor(public payload: { id: string }) {}
    }
    export class GetAllUserDetails {
      static readonly type = '[Account] Get All User Details'
      constructor() {}
    }
    export class UpdateUser {
      static readonly type = '[Account] Update'
      constructor(public payload: { user: UserViewModel }) {}
    }

    export class GetAssignSubApplications {
      static readonly type = '[Account] Load Assigned SubApplications'
      constructor(public payload: { userId: number; isActive?: boolean  }) {}
    }
  }